export default "__VITE_ASSET__CFiyZmDG__"